<script type="text/ecmascript-6">
import Layout from '../../layouts/Index'
import MainHeader from '../../layouts/Header'
import Sliders from './Slider';
import Ads from "./Ads";
import Recents from "./RecentPlay";
import Sections from "./Sections";
import Sectionstwo from "./Sections";
import { mapGetters } from 'vuex';

export default {
    name: 'home',

    metaInfo: {
        title: 'Melo Music'
    },

    data: () => ({
        data: null,
        loading: true,
    }),

    computed: {
        ...mapGetters({
            isAuthenticated: 'isAuthenticated'
        }),

    },

    components: {
        Ads,
        Layout,
        MainHeader,
        Sliders,
        Recents,
        Sections,
        Sectionstwo
    },
    mounted() {
        this.getHome()
        if(this.isAuthenticated){
            this.$store.dispatch('userRequest');
        }
    },

    methods: {
        getHome() {
            console.log("calling home api")
            axios.get('/api/v2/home').then((response) => {
                this.data = response.data;
                // console.log("data: ",this.data)
                // this.data.recents = [
                //     {
                //         description:"Eint Chit",
                //         id:6815,
                //         image:"https://melo-assets.s3-ap-southeast-1.amazonaws.com/photos/album/G6j3s2iyxmWA5HzRdC7OZSUPlxjKbp1723517878.jpg",
                //         name:"တိမ်တိုက်မျက်ရည်",
                //         name_en:"Tain Tike Myat Yay",
                //         recent_id:4877785,
                //         type:"album",
                //         uuid:"c8051dfa-24b9-44e6-a885-8d26eb9eea62"
                //     },
                //     {
                //         description: "Eint Chit",
                //         id: 6815,
                //         image: "https://melo-assets.s3-ap-southeast-1.amazonaws.com/photos/album/G6j3s2iyxmWA5HzRdC7OZSUPlxjKbp1723517878.jpg",
                //         name: "တိမ်တိုက်မျက်ရည်",
                //         name_en: "Tain Tike Myat Yay",
                //         recent_id: 4877785,
                //         type: "album",
                //         uuid: "c8051dfa-24b9-44e6-a885-8d26eb9eea62"
                //     },
                //     {
                //         description: "Eint Chit",
                //         id: 6815,
                //         image: "https://melo-assets.s3-ap-southeast-1.amazonaws.com/photos/album/G6j3s2iyxmWA5HzRdC7OZSUPlxjKbp1723517878.jpg",
                //         name: "တိမ်တိုက်မျက်ရည်",
                //         name_en: "Tain Tike Myat Yay",
                //         recent_id: 4877785,
                //         type: "album",
                //         uuid: "c8051dfa-24b9-44e6-a885-8d26eb9eea62"
                //     },
                //     {
                //         description: "Eint Chit",
                //         id: 6815,
                //         image: "https://melo-assets.s3-ap-southeast-1.amazonaws.com/photos/album/G6j3s2iyxmWA5HzRdC7OZSUPlxjKbp1723517878.jpg",
                //         name: "တိမ်တိုက်မျက်ရည်",
                //         name_en: "Tain Tike Myat Yay",
                //         recent_id: 4877785,
                //         type: "album",
                //         uuid: "c8051dfa-24b9-44e6-a885-8d26eb9eea62"
                //     },
                //     {
                //         description: "Eint Chit",
                //         id: 6815,
                //         image: "https://melo-assets.s3-ap-southeast-1.amazonaws.com/photos/album/G6j3s2iyxmWA5HzRdC7OZSUPlxjKbp1723517878.jpg",
                //         name: "တိမ်တိုက်မျက်ရည်",
                //         name_en: "Tain Tike Myat Yay",
                //         recent_id: 4877785,
                //         type: "album",
                //         uuid: "c8051dfa-24b9-44e6-a885-8d26eb9eea62"
                //     },
                //     {
                //         description: "Eint Chit",
                //         id: 6815,
                //         image: "https://melo-assets.s3-ap-southeast-1.amazonaws.com/photos/album/G6j3s2iyxmWA5HzRdC7OZSUPlxjKbp1723517878.jpg",
                //         name: "တိမ်တိုက်မျက်ရည်",
                //         name_en: "Tain Tike Myat Yay",
                //         recent_id: 4877785,
                //         type: "album",
                //         uuid: "c8051dfa-24b9-44e6-a885-8d26eb9eea62"
                //     },
                //     {
                //         description: "Eint Chit",
                //         id: 6815,
                //         image: "https://melo-assets.s3-ap-southeast-1.amazonaws.com/photos/album/G6j3s2iyxmWA5HzRdC7OZSUPlxjKbp1723517878.jpg",
                //         name: "တိမ်တိုက်မျက်ရည်",
                //         name_en: "Tain Tike Myat Yay",
                //         recent_id: 4877785,
                //         type: "album",
                //         uuid: "c8051dfa-24b9-44e6-a885-8d26eb9eea62"
                //     },
                //     {
                //         description: "Eint Chit",
                //         id: 6815,
                //         image: "https://melo-assets.s3-ap-southeast-1.amazonaws.com/photos/album/G6j3s2iyxmWA5HzRdC7OZSUPlxjKbp1723517878.jpg",
                //         name: "တိမ်တိုက်မျက်ရည်",
                //         name_en: "Tain Tike Myat Yay",
                //         recent_id: 4877785,
                //         type: "album",
                //         uuid: "c8051dfa-24b9-44e6-a885-8d26eb9eea62"
                //     },
                //      {
                //         description: "Eint Chit",
                //         id: 6815,
                //         image: "https://melo-assets.s3-ap-southeast-1.amazonaws.com/photos/album/G6j3s2iyxmWA5HzRdC7OZSUPlxjKbp1723517878.jpg",
                //         name: "တိမ်တိုက်မျက်ရည်",
                //         name_en: "Tain Tike Myat Yay",
                //         recent_id: 4877785,
                //         type: "album",
                //         uuid: "c8051dfa-24b9-44e6-a885-8d26eb9eea62"
                //     },
                //      {
                //         description: "Eint Chit",
                //         id: 6815,
                //         image: "https://melo-assets.s3-ap-southeast-1.amazonaws.com/photos/album/G6j3s2iyxmWA5HzRdC7OZSUPlxjKbp1723517878.jpg",
                //         name: "တိမ်တိုက်မျက်ရည်",
                //         name_en: "Tain Tike Myat Yay",
                //         recent_id: 4877785,
                //         type: "album",
                //         uuid: "c8051dfa-24b9-44e6-a885-8d26eb9eea62"
                //     },
                //      {
                //         description: "Eint Chit",
                //         id: 6815,
                //         image: "https://melo-assets.s3-ap-southeast-1.amazonaws.com/photos/album/G6j3s2iyxmWA5HzRdC7OZSUPlxjKbp1723517878.jpg",
                //         name: "တိမ်တိုက်မျက်ရည်",
                //         name_en: "Tain Tike Myat Yay",
                //         recent_id: 4877785,
                //         type: "album",
                //         uuid: "c8051dfa-24b9-44e6-a885-8d26eb9eea62"
                //     },
                //      {
                //         description: "Eint Chit",
                //         id: 6815,
                //         image: "https://melo-assets.s3-ap-southeast-1.amazonaws.com/photos/album/G6j3s2iyxmWA5HzRdC7OZSUPlxjKbp1723517878.jpg",
                //         name: "တိမ်တိုက်မျက်ရည်",
                //         name_en: "Tain Tike Myat Yay",
                //         recent_id: 4877785,
                //         type: "album",
                //         uuid: "c8051dfa-24b9-44e6-a885-8d26eb9eea62"
                //     },
                //      {
                //         description: "Eint Chit",
                //         id: 6815,
                //         image: "https://melo-assets.s3-ap-southeast-1.amazonaws.com/photos/album/G6j3s2iyxmWA5HzRdC7OZSUPlxjKbp1723517878.jpg",
                //         name: "တိမ်တိုက်မျက်ရည်",
                //         name_en: "Tain Tike Myat Yay",
                //         recent_id: 4877785,
                //         type: "album",
                //         uuid: "c8051dfa-24b9-44e6-a885-8d26eb9eea62"
                //     },
                //      {
                //         description: "Eint Chit",
                //         id: 6815,
                //         image: "https://melo-assets.s3-ap-southeast-1.amazonaws.com/photos/album/G6j3s2iyxmWA5HzRdC7OZSUPlxjKbp1723517878.jpg",
                //         name: "တိမ်တိုက်မျက်ရည်",
                //         name_en: "Tain Tike Myat Yay",
                //         recent_id: 4877785,
                //         type: "album",
                //         uuid: "c8051dfa-24b9-44e6-a885-8d26eb9eea62"
                //     },
                //      {
                //         description: "Eint Chit",
                //         id: 6815,
                //         image: "https://melo-assets.s3-ap-southeast-1.amazonaws.com/photos/album/G6j3s2iyxmWA5HzRdC7OZSUPlxjKbp1723517878.jpg",
                //         name: "တိမ်တိုက်မျက်ရည်",
                //         name_en: "Tain Tike Myat Yay",
                //         recent_id: 4877785,
                //         type: "album",
                //         uuid: "c8051dfa-24b9-44e6-a885-8d26eb9eea62"
                //     },
                //      {
                //         description: "Eint Chit",
                //         id: 6815,
                //         image: "https://melo-assets.s3-ap-southeast-1.amazonaws.com/photos/album/G6j3s2iyxmWA5HzRdC7OZSUPlxjKbp1723517878.jpg",
                //         name: "တိမ်တိုက်မျက်ရည်",
                //         name_en: "Tain Tike Myat Yay",
                //         recent_id: 4877785,
                //         type: "album",
                //         uuid: "c8051dfa-24b9-44e6-a885-8d26eb9eea62"
                //     },
                //     {
                //         description: "Eint Chit",
                //         id: 6815,
                //         image: "https://melo-assets.s3-ap-southeast-1.amazonaws.com/photos/album/G6j3s2iyxmWA5HzRdC7OZSUPlxjKbp1723517878.jpg",
                //         name: "တိမ်တိုက်မျက်ရည်",
                //         name_en: "Tain Tike Myat Yay",
                //         recent_id: 4877785,
                //         type: "album",
                //         uuid: "c8051dfa-24b9-44e6-a885-8d26eb9eea62"
                //     }
                // ];
                // console.log(JSON.stringify(this.data.recents, null, 2));
                this.loading = false;
            }).catch((error) => {
                console.log(error, "error data fetching")
                this.loading = false;
            });
        },

    }


}
</script>

<template>
    <layout>

        <div class="ms_content_wrapper ms_profile">

            <main-header/>

            <div class="header_padder_top"></div>

            <div v-show="!loading">
                <div v-for="(value,key) in data">
                    <component v-bind:is="key" :data="value"></component>
                </div>
            </div>
            <div style="height:100vh;align-items: center;display: flex;margin-top: -10%;" v-show="loading">
                <div class="more_loading">
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                    <div class="bar"></div>
                </div>
            </div>
        </div>


    </layout>

</template>
